import { render, staticRenderFns } from "./focus-areas.vue?vue&type=template&id=c34b97ae&scoped=true&"
import script from "./focus-areas.vue?vue&type=script&lang=js&"
export * from "./focus-areas.vue?vue&type=script&lang=js&"
import style0 from "./focus-areas.vue?vue&type=style&index=0&id=c34b97ae&scoped=true&lang=css&"
import style1 from "./focus-areas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34b97ae",
  null
  
)

export default component.exports